<template>
  <div>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>1. Change Reason</v-card-title>
          <v-card-text>{{mapChangeReason[formData.changeReason]}}</v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <template v-if="formData.changeReason==='CHANGE_ADD_ONS'">
      <SiteAddonsView :isStep="2" :addons="formData.siteAddons" :unavailable="unavailable.siteAddons"/>
      <UserAddonsView :isStep="3" :users="formData.users" :userAddons="userAddons" :unavailable="unavailable.userAddons"/>
    </template>
    <template v-if="selectedChangeReason">
      <TariffView :isStep="2"  :formData="formData"/>
      <SiteAddonsView :isStep="3" :addons="formData.siteAddons" :unavailable="unavailable.siteAddons"/>
      <UserAddonsView :isStep="4" :users="formData.users" :userAddons="userAddons" :unavailable="unavailable.userAddons"/>
      <AdhocChargesView :isStep="5" :adhoc="adhoc"/>
    </template>
  </div>
</template>

<script>
  import SiteAddonsView from "./SiteAddonsView";
  import UserAddonsView from "./UserAddonsView";
  import TariffView from "./TariffView";
  import AdhocChargesView from "./AdhocChargesView";
  export default {
    components: { SiteAddonsView,UserAddonsView,TariffView,AdhocChargesView },
    data() {
      return {
        mapChangeReason: {
          'CHANGE_ADD_ONS': 'Change Add-ons',
          'RETENTION': 'Retention',
          'RENEWAL': 'Contract Renewal',
          'CHANGE_PRODUCT': 'Change Product',
          'PRE_LIVE': 'Pre-live',
        }
      }
    },
    props: ['currentStep','formData','userAddons','unavailable','adhoc'],

    computed: {
      selectedChangeReason() {
        return this.formData.changeReason === 'RENEWAL' || this.formData.changeReason === 'RETENTION' || this.formData.changeReason === 'PRE_LIVE' || this.formData.changeReason === 'CHANGE_PRODUCT';
      }
    }
  }
</script>

<style lang="scss" scoped></style>
